// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".socialEntrance_authSocial__1EINb {\n  margin-top: 8px;\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n}", ""]);
// Exports
exports.locals = {
	"authSocial": "socialEntrance_authSocial__1EINb"
};
module.exports = exports;
